import React, { forwardRef } from "react";
import { Barcompensacion } from '../components/Barcompensacion';
import { MedirCompensacion } from '../components/MedirCompensacion';
import { getCompensacion, deleteCompensacion, getCompensacionGrupos } from '../firebase';
import * as XLSX from 'xlsx';
import MaterialTable from 'material-table';

import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import Export from '@material-ui/icons/CloudDownload'

const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};

function Compensacion() {
  var [columns, setColumns] = React.useState(
    [
        { title: 'ID', field: 'id', editable: false, hidden: true},
        { title: 'Proyecto', field:'nombre_proyecto'},
        { title: 'Grupo1', field: 'Grupo1'},
        { title: 'cant  árboles', field: 'cant1'},
        { title: 'Grupo2', field: 'Grupo2'},
        { title: 'cant  árboles', field: 'cant2'},
        { title: 'Grupo3', field: 'Grupo3'},
        { title: 'cant  árboles', field: 'cant3'},
        { title: 'Grupo4', field: 'Grupo4'},
        { title: 'cant  árboles', field: 'cant4'},
        { title: 'Grupo5', field: 'Grupo5'},
        { title: 'cant  árboles', field: 'cant5'},
        { title: 'Grupo6', field: 'Grupo6'},
        { title: 'cant  árboles', field: 'cant6'},
        { title: 'Total árboles', field: 'cantTotal'},
        { title: 'Compensación (Kg CO2 eq)', field: 'total_captura'},
        { title: 'Año', field: 'year'}
    ]
  );

  const [loading, setLoading] = React.useState(false);
  const [data, setData] = React.useState(null)
  const [compensaYears, setCompensaYears] = React.useState(null);
  const [compensaValues, setCompensaValues] = React.useState(null);

  const [datosCompensa, setDatosCompensa] = React.useState([]);
  const [gruposCompensa, setGruposCompensa] = React.useState([])

  React.useEffect(() => {
    getGruposFromServer();
    console.log('Actualizando getCompensacionFormServer')
  },[])

  const getGruposFromServer = async ()=> {
    setLoading(true)
    let grupos = [];
      await getCompensacionGrupos()
      .then((snapshot) => {
        snapshot.docs.forEach((doc) => {
          grupos.push({ ...doc.data(), id: doc.id});
        });
        setGruposCompensa(grupos);
      })
  }

  React.useEffect(() => {
    getCompensacionFromServer();
    console.log('Actualizando getCompensacionFormServer')
  },[])

  const getCompensacionFromServer = async ()=> {
    setLoading(true);
    let years = []
    let values = [];
    let data1 = [];
    let datos = [];
    await getCompensacion()
    .then((snapshot) => {
      
        snapshot.docs.forEach((doc) => {
            data1.push({ ...doc.data(), id: doc.id })
        })
        // Sort by year
        const sortData = data1.sort((a,b) => a.year - b.year);
        setData(sortData);
        if (data1 !== null || data1 !== undefined || data1 !== false) {
          let acumuladoYear = 0;
          let lastYear = 2020;
          data1.forEach(dat => {
            console.log('dat.year=='+dat.year);
            console.log('dat.total_captura=='+dat.total_captura * -1);

            years.push(dat.year);
            values.push(dat.total_captura * -1);
            //datos.push({year:dat.year, value:((dat.total_captura * -1) -  acumuladoYear)})
            // Ajueste realizado Deciembre 21 2023, por instrucciones de Juan Diego Rogriguez
            // No acumular la compensación y solo visualizar año a año
            datos.push({year:dat.year, value:(dat.total_captura * -1)})

            //acumuladoYear -= dat.total_captura * -1;
            acumuladoYear = dat.total_captura * -1;
            lastYear = dat.year;
            acumuladoYear = 0;
          });
          if (acumuladoYear > 0) { acumuladoYear = acumuladoYear * -1}

          while (lastYear < 2030) {
            lastYear += 1; 
            years.push(lastYear);
            values.push(acumuladoYear);
            datos.push({year:lastYear, value:acumuladoYear })
          }
          

        }
        console.log('datosCompensa = '+ datos)
        setDatosCompensa(datos);
        setCompensaValues(values);
        setCompensaYears(years);
        
    })
  }
  const handleDelete = async (id)=>  {
    const borrado = await deleteCompensacion(id);
    console.log('¿SI borró?' +borrado);
    if (borrado) {
      handleCallback();
    }else{
        alert('Ocurrio una novedad en el borrado!');
    }
  }

  const exportExcel=()=>{
    const workSheet=XLSX.utils.json_to_sheet(data)
    const workBook=XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workBook, workSheet,"datos")
    //Buffer
    let buf=XLSX.write(workBook,{bookType:"xlsx",type:"buffer"})
    //Binary string
    XLSX.write(workBook,{bookType:"xlsx",type:"binary"})
    //Download file
    XLSX.writeFile(workBook,"huella_carbono.xlsx")
    
  }
  const handleCallback = () => {
    getCompensacionFromServer();
    console.log('Actualizando getCompensacionFormServer')
  }
    return (
      <div id='cards' className='cards'>
      <h1 style={{ position:'relative', top:'20px', color:'#115BFF'}}><span style={{ background:'#0B149D',color:'white',fontWeight:'bold'}}>Compensación</span> de tu huella de carbono (Kg CO<sub>2</sub>eq.)</h1>
      
      <div className='cards__container'>
        <div className='cards__wrapper' style={{width:'100%'}}>

          <ul className='cards__items'>
            <div style={{ width:'100%'}}>
              <div>{ (compensaValues !== null && compensaYears !== null) ?
                <Barcompensacion
                  compensaYears={compensaYears} 
                  compensaValues={compensaValues}
                  datos={datosCompensa}>
                </Barcompensacion>
                :
                <img src='/loading.gif'></img>
              }
              </div>
            </div>
          </ul>


          <ul className='cards__items'>
            <li className='cards__item' style={{width:'80%', boxShadow:' 0 6px 20px rgb(56 125 255 / 17%)',
              filter:' drop-shadow(0 6px 20px rgba(56, 125, 255, 0.017))'}}>
              <div className='cards__item__link'>
                <div style={{textAlign:'Center'}}>
                  
                  <span style={{color:'#0B149D', fontSize:'18px'}}>Proyectos actuales</span>
                  
                    { data !== null &&
                      
                      <MaterialTable
                        title="Entradas por cada subcategoría "
                        columns={columns}
                        data={(data)}
                        icons={tableIcons}
                        actions={[
                            {
                                icon:Export,
                                tooltip:"Exportat a Excel",
                                onClick:()=>exportExcel(),
                                isFreeAction:true
                            }
                        ]}
                        editable={{
                            onRowDelete: (rowDelete) => new Promise((resolve, reject) => {
                              const index = rowDelete.tableData.id;
                              const updateRows = [...data]
                              updateRows.splice(index,1)

                              setTimeout(() => { 
                                handleDelete(rowDelete.id);
                                setData(updateRows)
                                resolve();
                              }, 2000)
                            }),
                            onRowAddCancelled: rowData => console.log('Row adding cancelled'),
                            onRowUpdateCancelled: rowData => console.log('Row editing cancelled'),
                
                        }}
                        localization={{ body: { editRow: { deleteText: '¿Realmente desea borrar este registro?' } }, 
                                        header: { actions: 'Acciones' }
                        }}
                      />
                    }
                </div>
              </div>
            </li>
            <li className='cards__item' style={{boxShadow:' 0 6px 20px rgb(56 125 255 / 17%)',
              filter:' drop-shadow(0 6px 20px rgba(56, 125, 255, 0.017))'}}>
              <div className='cards__item__link'>
                {/*<MedirCompensacion user={props.user}></MedirCompensacion>*/}
                <MedirCompensacion parentCallback={handleCallback} grupos={gruposCompensa}></MedirCompensacion>
              </div>
            </li>
            
          </ul>
        </div>
      </div>
    </div>
    )
}

export {Compensacion}